import { Table as MUITable, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import css from './index.module.scss';
import classNames from 'classnames';
import { TableProps } from './index.types';
import { GoMotoComponent } from '../../API/GoMoto.types';

export type { TableProps as GMTableProps };

export const Table: GoMotoComponent<TableProps> = (props) => (
    <MUITable className={css.table}>
        <TableHead className={css.head}>
            <TableRow className={css.row}>
                {props.headers.map((h, index) => (
                    <TableCell className={css.cell} key={index}>
                        {h}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
        <TableBody className={css.body}>
            {props.rows.map((row, rowIndex) => (
                <TableRow
                    key={rowIndex}
                    classes={{
                        root: classNames(css.row, { [css.alternate]: rowIndex % 2 }),
                        hover: css.hover,
                    }}
                >
                    {row.map((cell, cellIndex) => (
                        <TableCell className={css.cell} key={'' + rowIndex + cellIndex}>
                            {cell}
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    </MUITable>
);

export { default as GMTable } from './Table/Table';
